/**
 * Troca de idioma com persistência no perfil do usuário.
 *
 * Separado do componente de seleção para não misturar função e componentes no
 * mesmo módulo (react-refresh) e para que outras telas possam trocar o idioma
 * sem depender do seletor.
 */
import { toast } from 'sonner';
import api from '../services/api';
import TokenService from '../services/token.service';
import i18n, { trocarIdioma } from './index';

/**
 * Aplica o idioma imediatamente (RF05) e depois persiste no perfil.
 *
 * Se a gravação falhar, a interface permanece no idioma escolhido: a preferência
 * continua valendo neste dispositivo pelo localStorage. Por isso o erro vira aviso,
 * e não rollback.
 *
 * @param {string} codigo Tag BCP-47 ('pt-BR', 'en-US')
 */
export async function alterarIdioma(codigo) {
    await trocarIdioma(codigo);

    // Usa o singleton, e não o `t` capturado pelo componente no clique: aquele
    // ainda está preso ao idioma anterior, e a confirmação sairia no idioma que
    // o usuário acabou de abandonar.
    const traduzir = i18n.t.bind(i18n);

    // Na tela de login ainda não há usuário: a escolha vale só para o dispositivo.
    if (!TokenService.getLocalAccessToken()) {
        return;
    }

    try {
        await api.put('/usuarios/minha_conta/', { language: codigo });
        toast.success(traduzir('common:language.changed'));
    } catch (erro) {
        console.error('[i18n] Falha ao salvar a preferência de idioma:', erro);
        toast.error(traduzir('common:language.changeError'));
    }
}

export default alterarIdioma;
